import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Position, ExamLocation, PositionSelection } from '../models/position.model';
import { ApiResponse } from '../models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class PositionService {
  private apiUrl = `${environment.apiUrl}/positions`;

  constructor(private http: HttpClient) {}

  /**
   * Get all positions for a contest
   */
  getPositionsByContest(contestId: number): Observable<ApiResponse<Position[]>> {
    return this.http.get<ApiResponse<Position[]>>(`${this.apiUrl}/contest/${contestId}`);
  }

  /**
   * Get position by ID
   */
  getPositionById(id: number): Observable<ApiResponse<Position>> {
    return this.http.get<ApiResponse<Position>>(`${this.apiUrl}/${id}`);
  }

  /**
   * Get exam locations for a position
   */
  getExamLocations(positionId: number): Observable<ApiResponse<ExamLocation[]>> {
    return this.http.get<ApiResponse<ExamLocation[]>>(`${this.apiUrl}/${positionId}/locations`);
  }

  /**
   * Select position and exam location for enrollment
   */
  selectPosition(data: PositionSelection): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(`${this.apiUrl}/select`, data);
  }

  /**
   * Update position selection
   */
  updatePositionSelection(enrollmentId: number, data: PositionSelection): Observable<ApiResponse<any>> {
    return this.http.put<ApiResponse<any>>(`${this.apiUrl}/select/${enrollmentId}`, data);
  }
}
